import { render, staticRenderFns } from "./customer-query.vue?vue&type=template&id=4688c2ca&"
import script from "./customer-query.vue?vue&type=script&lang=ts&"
export * from "./customer-query.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports